import "./Studio.css";
import img1 from "../../assets/numbers/1.png"
import img2 from "../../assets/numbers/2.png"
import img3 from "../../assets/numbers/3.png"
import img4 from "../../assets/numbers/4.png"
import img5 from "../../assets/numbers/5.png"
import img6 from "../../assets/numbers/6.png"
import img7 from "../../assets/numbers/7.png"
import studio from "../../assets/Studio icon.png"
import {useState,useEffect} from "react";
import Loading from "../UI/Loading/Loading";


const Studio = () => {

    const [state, setState] = useState({
        email: null
    })

    const placeEmailHandler = (e) => {
        let val = e.target.value
        setState(val)
    }

    const [loading, setLoading] = useState(true)
    useEffect(() => {
        window.scrollTo(0, 0);
        const loadingTimeout = setTimeout(() => {
            setLoading(false);
        }, 2000);

        return () => {
            clearTimeout(loadingTimeout);
        };
    }, [])

    return (
        <>
            {loading && <Loading/>}
            <div className={"studio-container"}>
                <div className="studio-first">
                    <h1 className={"upToBottomAnimation"}>
                        Arnika Studio
                    </h1>
                    <div className={"upToBottomAnimation"}>
                        World-class support and mentorship.
                    </div>
                </div>
                <div className="studio-second-container">
                    <div className="studio-second">
                        <img src={studio} alt=""/>
                        <h1>
                            Startups
                        </h1>
                        <div>
                            Constantly appraising the startup landscape, we identify and partner with founders to create,
                            extend
                            and improve fascinating products and services. ArnikUp focuses on just a few projects at any one
                            time, paying detailed attention to strategy, direction, business model, market, as well as the
                            inner
                            workings of the company itself and elevate it so that it is in a position to offer high-impact
                            products and services efficiently, economically and, with speed.
                            <br/>
                            We mostly collaborate with already operational startups in need of a boost, but are also on the
                            lookout for talented and capable individuals who can carry novel business ideas from inception
                            to
                            fruition.
                        </div>
                    </div>
                </div>
                <div className="studio-third-container">
                    <div className="studio-third">
                        <h1>Investors</h1>
                        <div className={"studio-third-div"}>
                            <div>
                                <img src={img1} alt=""/>
                                <h2>Filtering:</h2>
                                <p>We will only bring you fully vetted startups after exhaustive business viability
                                    tests.</p>
                            </div>
                            <div>
                                <img src={img2} alt=""/>
                                <h2>Risk Reduction:</h2>
                                <p>We use scientific tools and techniques to ensure that investment risks are at their
                                    absolute minimum.</p>
                            </div>
                            <div>
                                <img src={img3} alt=""/>
                                <h2>Ready-made product/services:</h2>
                                <p>We bring you a complete package of a viable business, team and product already up and
                                    running.</p>
                            </div>
                            <div>
                                <img src={img4} alt=""/>
                                <h2>Sustained Growth:</h2>
                                <p>Bringing realistic long term strategy and plans to ensure growth and sustained
                                    profitability complete with milestones and KIPs.</p>
                            </div>
                            <div>
                                <img src={img5} alt=""/>
                                <h2>Capital Aficiency & Growth:</h2>
                                <p>We will ensure that your investment will be put to efficient, mature and thoughtful
                                    use.</p>
                            </div>
                            <div>
                                <img src={img6} alt=""/>
                                <h2>Exit strategies:</h2>
                                <p>We facilitate such strategies through formulation and roadmaps to execuction.</p>
                            </div>
                            <div>
                                <img src={img7} alt=""/>
                                <h2>Due Diligence:</h2>
                                <p>We take the pain out of separating the wheat from the chaff by conducting thorough and
                                    comprehensive analysis from a variety of core angles.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="studio-email">
                    <h1>
                        Would you like to collaborate?
                    </h1>
                    <p>
                        Insert your email
                    </p>
                    <div>
                        <input type="email" name={"email"} value={state.email} onChange={placeEmailHandler}
                               placeholder={"example@gmail.com"}/>
                        <button>Send</button>
                    </div>
                </div>
            </div>
        </>

    )
}
export default Studio;